import { useGLTF } from '@react-three/drei';
import { useEffect } from 'react';
import { useSpring, animated } from '@react-spring/three';
import { useStore } from '../store';

export default function HomepageLogo() {
  const gltf = useGLTF('/models/aesthetic.gltf');
  const isAnimating = useStore((state) => state.isAnimating);
  
  const springs = useSpring({
    from: { y: 10 },
    to: { y: isAnimating ? 0 : 10 },
    config: {
      mass: 1,
      tension: 80,
      friction: 20,
      bounce: 0.25
    },
  });

  useEffect(() => {
    if (gltf.scene) {
      gltf.scene.traverse((child) => {
        if (child.isMesh) {
          child.material.metalness = 1;
          child.material.roughness = .07;
          child.material.envMapIntensity = 1.05;
        }
      });
    }
  }, [gltf]);

  return (
    <animated.group position-y={springs.y}>
      <primitive 
        object={gltf.scene} 
        scale={0.35}
      />
    </animated.group>
  );
}

useGLTF.preload('/models/homepage.gltf');